<template>
    <div class="courses-single-page bg-dark-blue" v-if="coupons" style="overflow-y: auto;">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="course-single tab-content m-2 p-0">
                            <div class="card">
                                <div class="container-fluid">
                                    <div class="content pt-3">
                                        <form class="form" v-on:submit="generateCoupons">
                                            <div class="row">
                                                <div class="col">
                                                    <div class="card m-1 bg-dark-blue">
                                                        <div class="container-fluid text-white">
                                                            <div class="d-flex justify-content-between p-2">
                                                                <div class="title text-white">
                                                                    Generate coupons
                                                                </div>
                                                            </div>
                                                            <div class="form-group">
                                                                <label class="text-white">Coupon Description (Comma delimited format)</label>
                                                                <input class="form-control" type="text" v-model="couponDescription" placeholder="Description.." />
                                                            </div>
                                                            <div class="form-group">
                                                                <label class="text-white">How many</label>
                                                                <input class="form-control" type="number" v-model.number="couponQuantity" />
                                                            </div>
                                                            <div class="form-group">
                                                                <label class="text-white">Discount percentage %</label>
                                                                <input class="form-control" type="number" v-model.number="couponDiscountPercentage" />
                                                            </div>
                                                            <div class="form-group">
                                                                <label class="text-white">Behaviour</label>
                                                                <select v-model="couponBehaviour">
                                                                    <option value="single">Applies to a single course</option>
                                                                    <option value="all">Applies to all courses</option>
                                                                </select> 
                                                            </div>
                                                            <div class="d-flex justify-content-end m-1 mb-3">
                                                                <button class="btn-generate text-uppercase" type="submit">Generate</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4" v-if="userRole == 'admin'">
                                                    <div class="container-fluid assigned-courses">
                                                        <div class="title text-dark-blue">
                                                            Assigned to coupon
                                                        </div>
                                                        <div class="container" style="height: 320px; overflow-y: auto;">
                                                            <ul>
                                                                <li v-for="course in assignedCourses">
                                                                    <div class="row">
                                                                        <div class="col-6 pl-0">
                                                                            <i class="fa fa-check-circle mr-2 text-dark-blue"></i>
                                                                            <span>
                                                                                {{course.siteName}}
                                                                            </span>
                                                                        </div>
                                                                        <div class="col-6">
                                                                            <span>
                                                                                {{course.name}}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li v-show="assignedCourses.length < 1">No courses selected</li>
                                                            </ul>
                                                        </div>
                                                        <div class="d-flex justify-content-end">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="container-fluid mt-2">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex align-items-center">
                                                        <div class="title text-dark-blue mr-4">
                                                            Assign Courses
                                                        </div>
                                                        <div class="site-select mb-2" v-if="userRole && sites && userRole == 'admin'">
                                                            <select v-model="selectedSite">
                                                                <option v-for="site in sites" :value="site">{{site.name}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                                <div style="max-height: 400px; overflow-y: auto">
                                                    <table class="table table-bordered text-center" style="background-color: white;">
                                                        <thead>
                                                            <tr>
                                                                <th>Course Id</th>
                                                                <th>Course Name</th>
                                                                <th>Category</th>
                                                                <th>Assigned</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="course in filteredCourses">
                                                                <td>{{ course.id }}</td>
                                                                <td>{{ course.name }}</td>
                                                                <td>{{ course.category }}</td>
                                                                <td>
                                                                    <div class="d-flex justify-content-center">
                                                                        <input v-model="course.allocated" type="checkbox" />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr v-show="filteredCourses.length < 1">
                                                                <td colspan="4">
                                                                    No courses yet
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pl-2 pr-2">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="course-single tab-content p-0">
                            <div class="content pt-1">
                                <div class="container-fluid pl-0 pr-0">
                                    <div class="title text-white ml-4">
                                        Active Coupons
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table" style="background-color: white;">
                                            <thead>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Description</th>
                                                    <th>Created On</th>
                                                    <th>Code</th>
                                                    <th>Course IDs</th>
                                                    <th>Redeemed on</th>
                                                    <th>User ID</th>
                                                    <th>User email</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="coupon in filteredCoupons">
                                                    <td>{{ coupon.id }}</td>
                                                    <td>{{ coupon.description }}</td>
                                                    <td>{{ coupon.createTimestamp }}</td>
                                                    <td>{{ coupon.code }}</td>
                                                    <td>{{ coupon.courseIds }}</td>
                                                    <td>{{ coupon.redeemTimestamp ? coupon.redeemTimestamp : 'Not redeemed' }}</td>
                                                    <td>{{ coupon.redeemerUserId ? coupon.redeemerUserId : "None" }}</td>
                                                    <td>{{ coupon.redeemerUser == null ? "None" : coupon.redeemerUser.email }} </td>
                                                </tr>
                                                <tr v-show="filteredCoupons.length < 1">
                                                    <td colspan="8" class="text-center">
                                                        No coupons yet
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    #upload-file-modal {
        top: 30% !important;
        display: block;
    }

    .btn-generate {
        border: 1px solid #42c1c4;
        border-radius: 8px;
        background-color: #42c1c4;
        color: white;
        padding: 5px 25px;
    }

        .btn-generate:hover {
            background-color: white;
            color: #42c1c4;
        }
</style>

<script>
    export default {
        name: 'AdminCoupons',
        components: {


        },
        props: {

        },
        data() {
            return {
                courses: [],
                coupons: [],
                couponDescription: "",
                couponQuantity: 0,
                couponDiscountPercentage: 0,
                couponBehaviour: "single",
                selectedSite: null,
                sites: null
            }
        },
        computed: {
            userRole() {
                var user = this.$store.getters.getUser;

                if (user) {
                    var roles = this.$store.state.user.roles;
                    return roles[0];
                }
            },
            filteredCourses() {
                var filtered = [];

                if (this.userRole == "admin") {
                    for (var i = 0; i < this.courses.length; i++) {
                        var currentCourse = this.courses[i];
                        if (currentCourse.siteId == this.selectedSite.id) {
                            filtered.push(currentCourse);
                        }
                    }
                }
                else {
                    filtered = this.courses;
                }

                return filtered;
            },
            filteredCoupons() {
                var filtered = [];
                if (this.userRole == "admin" && this.selectedSite) {
                    for (var i = 0; i < this.coupons.length; i++) {
                        var currentCoupon = this.coupons[i];
                        if (currentCoupon.siteId == this.selectedSite.id) {
                            filtered.push(currentCoupon);
                        }
                    }
                }
                else {
                    filtered = this.coupons;
                }

                return filtered;
            },
            assignedCourses() {
                var assigned = [];
                if (this.courses) {
                    for (var i = 0; i < this.courses.length; i++) {
                        var current = this.courses[i];
                        if (current.allocated) {
                            assigned.push(current);
                        }
                    }
                }
                return assigned;
            },
        },
        methods: {
            getCourseNames() {
                //add later
            },
            async generateCoupons(event) {
                event.preventDefault();

                var courseIds = [];

                for (var i = 0; i < this.courses.length; i++) {
                    var course = this.courses[i];
                    if (course.allocated) {
                        course.allocated = false;
                        courseIds.push(course.id);
                    }
                }

                await this.web("/coupons", "Generating coupons...", {
                    courseIds: courseIds,
                    description: this.couponDescription,
                    count: this.couponQuantity,
                    discountPercentage: this.couponDiscountPercentage,
                    behaviour: this.couponBehaviour,
                    siteId : this.selectedSite.id
                });

                this.coupons = await this.web("/coupons", "Loading coupons");

                this.couponDescription = "";
                this.couponQuantity = 0;
                this.couponDiscountPercentage = 0;
            }
        },
        async mounted() {
            if (this.userRole == "admin") {
                var courses = await this.web("/courses?filters=admin&filters=all", "Loading courses");
                this.sites = await this.web("/sites?roles=admin&filters=courses", "Loading sites");
                this.selectedSite = this.sites[0];
                this.coupons = await this.web("/coupons?filters=admin", "Loading coupons");
            }
            else {
                var courses = await this.web("/courses?filters=all", "Loading courses");
                this.coupons = await this.web("/coupons?filters=none", "Loading coupons");
            }

            for (var i = 0; i < courses.length; i++) {
                var course = courses[i];
                course.allocated = false;
            }

            this.courses = courses;

            var crumbs = {};
            crumbs["/admin/coupons"] = "Coupons";
            this.$store.commit("breadCrumbs", crumbs);
        }
    }
</script>
